import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { APP_ROUTES } from '@taxora-accountant-core/util/constants/app-routes.constant';
import { AppState } from '@taxora-accountant-core/data-access/state/app.state';

export const anonGuard: CanActivateFn = () => {
  const store = inject(Store);
  const accessToken = store.selectSnapshot(AppState.accessToken);

  if (!accessToken) {
    const router = inject(Router);
    router.navigate([APP_ROUTES.AUTH.ROOT, APP_ROUTES.AUTH.LOGIN]);
    return false;
  }

  return true;
};
